import { useMemo } from "react";

export interface OutlookSourceSettingsText {
  labelText: string;
  hintText: string;
  notSetText: string;
  loadingText: string;
  loadErrorText: string;
}

export type OutlookSourceSettingsKind = "mail" | "tasks" | "calendar";

export const useOutlookSourceSettingsText = (
  t: (key: string) => string,
  kind: OutlookSourceSettingsKind,
): OutlookSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.outlook.${key}`);

    const labelKey =
      kind === "tasks"
        ? "tasksLabel"
        : kind === "calendar"
          ? "calendarLabel"
          : "mailLabel";
    const hintKey =
      kind === "tasks"
        ? "tasksHint"
        : kind === "calendar"
          ? "calendarHint"
          : "mailHint";
    const loadingKey = kind === "calendar" ? "calendarLoading" : "loading";
    const loadErrorKey =
      kind === "calendar" ? "calendarLoadError" : "loadError";

    return {
      labelText: tKey(labelKey),
      hintText: tKey(hintKey),
      notSetText: tKey("notSet"),
      loadingText: tKey(loadingKey),
      loadErrorText: tKey(loadErrorKey),
    };
  }, [kind, t]);
};
